import React from 'react';
import {Input, Modal, Typography} from 'antd';

const {Text} = Typography;

type Props = {
	open: boolean;
	name: string;
	onNameChange: (value: string) => void;
	onOk: () => void;
	onCancel: () => void;
	confirmLoading?: boolean;
};

const EditFolder: React.FC<Props> = ({
	open,
	name,
	onNameChange,
	onOk,
	onCancel,
	confirmLoading = false,
}) => (
	<Modal
		title="Редактирование папки"
		open={open}
		onOk={onOk}
		onCancel={onCancel}
		confirmLoading={confirmLoading}
		cancelText="Отмена"
		okText="Сохранить"
	>
		<div style={{display: 'flex', flexDirection: 'column', gap: 16, marginTop: 16}}>
			<div>
				<Text strong>Название папки</Text>
				<br />
				<Input
					value={name}
					onChange={e => onNameChange(e.target.value)}
					placeholder="Название"
					style={{width: '100%', marginTop: 4}}
				/>
			</div>
		</div>
	</Modal>
);

export default EditFolder;
